import {z} from '@hono/zod-openapi';

export const importHondaRecallResultSchema = z.object({
  importedCampaignCount: z.number().int().nonnegative(),
  importedVinCount: z.number().int().nonnegative(),
  closedCount: z.number().int().nonnegative(),
});

export type ImportHondaRecallResult = z.infer<typeof importHondaRecallResultSchema>;
